import React from 'react';

import { Listing } from '@klokhuis/core/ApiClient/Klokhuis';
import { useFilterSelectors } from '@klokhuis/modules/Properties/context/hooks/useFilterSelectors';
import { useListingSelectors } from '@klokhuis/modules/Properties/context/hooks/useListingSelectors';
import { ListingsContext } from '@klokhuis/modules/Properties/context/ListingsContext';

import { ListingCard } from '../ListingCard';
import ListingCardSkeleton from '../ListingCard/ListingCardSkeleton';

import styles from './GridGenerator.module.css';

interface GridGeneratorProps {
  listings: Array<Listing>;
}

const GridGeneratorInternal = ({ listings }: GridGeneratorProps) => {
  const isLoading = useListingSelectors().isLoading();
  const isMapView = useFilterSelectors().isMapView();
  const { favoriteIds } = ListingsContext.useContext();

  const skeletons = Array(6).fill(0);
  return (
    <div className={isMapView ? styles.mapviewGrid : styles.root}>
      {isLoading
        ? skeletons.map((_, index) => {
            const uniqueKey = `skeleton-${index}`;
            return <ListingCardSkeleton key={uniqueKey} />;
          })
        : listings.map((listing, index) => (
            <ListingCard
              key={listing.listingId}
              listingId={listing.listingId}
              thumbnailUrl={listing.thumbnailUrl}
              fullPreviewImageUrl={listing.thumbnailUrl}
              isTopAdvert={Boolean(listing.isTopAdvert)}
              streetName={listing.cityName?.toString() || ''}
              cityName={listing.cityName?.toString() || ''}
              areaOrLandmark={listing.areaOrLandmark || undefined}
              isFavorite={favoriteIds.has(listing.listingId)}
              plotArea={listing.plotArea}
              listingType={listing.listingTypeId}
              salePrice={listing.salePrice}
              isPriceNegotiable={listing.isActive}
              priority={index < 3}
              listingStatus={listing.listingStatus}
              plotAreaUnit={listing.plotAreaUnit ? listing.plotAreaUnit : undefined}
            />
          ))}
    </div>
  );
};

export const GridGenerator = React.memo(GridGeneratorInternal);
